import { customizeError, formatDate } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { REACT_APP_SEARCH_DETAILS_CLAIM_ID_URL } from '../../config/settings/environment'
import { CLAIMS_OPTIONS_DICTIONARY, INITIAL_CLAIM_TABLE, MECHANISM_DICTIONARY } from '../../config/settings/constant'
import { getClaimsTable, getEncryptClaim } from '../../services/claims'

export const GET_CLAIM_INFORMATION_TABLE = 'GET_CLAIM_INFORMATION_CHART'
export const GET_CLAIM_INFORMATION_TABLE_ERROR = 'GET_CLAIM_INFORMATION_CHART_ERROR'
export const GET_CLAIM_INFORMATION_TABLE_SUCCESS = 'GET_CLAIM_INFORMATION_CHART_SUCCESS'
export const onGetClaimInformationTable = makeActionCreator(GET_CLAIM_INFORMATION_TABLE)
export const onGetClaimInformationTableError = makeActionCreator(GET_CLAIM_INFORMATION_TABLE_ERROR, 'payload')
export const onGetClaimInformationTableSuccess = makeActionCreator(GET_CLAIM_INFORMATION_TABLE_SUCCESS, 'payload')
export const onGetClaimInformationTableThunk = (payload, type) => async dispatch => {
  dispatch(onGetClaimInformationTable())

  try {
    const { data } = await getClaimsTable({ actionType: GET_CLAIM_INFORMATION_TABLE, dni: payload, type })
    let gridData = []

    gridData = data.payload?.data?.map(item => {
      return {
        claimId: item.idReclamo,
        complainant: item.reclamante,
        entryDate: formatDate(new Date(item.fechaDeIngreso), 'dd-MM-yyyy'),
        mechanism: {
          ...MECHANISM_DICTIONARY[item.tipoProcesoReclamado],
          type: item.tipoProcesoReclamado
        },
        originId: item.idOrigen,
        processClaim: item.procesoReclamado,
        status: item.estadoReclamo,
        typeOfClaim: item.tipoDeReclamo
      }
    })

    if (type === CLAIMS_OPTIONS_DICTIONARY.irregularity || type === CLAIMS_OPTIONS_DICTIONARY.paymentNotTime) {
      if (data.payload?.data.length === 0) {
        gridData = INITIAL_CLAIM_TABLE
      }
    }

    const hasData = gridData.length > 0
    const excelData = gridData.map(item => {
      return {
        'ID Reclamo': item.claimId,
        'Proceso reclamado': item.processClaim,
        'Tipo de Reclamo': item.typeOfClaim,
        'Fecha de ingreso': item.entryDate,
        Reclamante: item.complainant,
        Estado: item.status
      }
    })

    return dispatch(
      onGetClaimInformationTableSuccess({
        gridData,
        excelData,
        hasData
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetClaimInformationTableError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const GET_ENCRYPT_CLAIM = 'GET_ENCRYPT_CLAIM'
export const GET_ENCRYPT_CLAIM_ERROR = 'GET_ENCRYPT_CLAIM_ERROR'
export const GET_ENCRYPT_CLAIM_SUCCESS = 'GET_ENCRYPT_CLAIM_SUCCESS'
export const onGetEncryptClaim = makeActionCreator(GET_ENCRYPT_CLAIM)
export const onGetEncryptClaimError = makeActionCreator(GET_ENCRYPT_CLAIM_ERROR, 'payload')
export const onGetEncryptClaimSuccess = makeActionCreator(GET_ENCRYPT_CLAIM_SUCCESS, 'payload')
export const onGetEncryptClaimThunk = payload => async dispatch => {
  dispatch(onGetEncryptClaim())

  try {
    const { data } = await getEncryptClaim({
      actionType: GET_ENCRYPT_CLAIM,
      claimId: payload.id
    })

    window.open(`${REACT_APP_SEARCH_DETAILS_CLAIM_ID_URL}?qs=${data?.payload?.encrypt}`, 'Ficha_Compra')

    return dispatch(
      onGetEncryptClaimSuccess({
        encrypt: data?.payload?.encrypt
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetEncryptClaimError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
